import {Col, Row} from "react-bootstrap";
import {Link} from "react-router-dom";
import {VscTarget} from "react-icons/vsc";
import {PiSyringeThin} from "react-icons/pi";
import {FaRegBell} from "react-icons/fa";
import {useTranslation} from "react-i18next";

const ShowReminderSchedule = (props) => {
    const {t, i18n} = useTranslation();
    return (
        <Col className={'d-flex justify-content-start flex-column'}>
            <Row>
                <Col className={'mb-3'}>
                    <b>{t("reminderSchedule")}</b>
                </Col>
            </Row>
            <Row className={'align-items-center mx-0  mb-3'}>

                <Col md={12} className={'px-1 text-start'}>
                    <Link className={'btn btn-secondary w-100 text-black border-groove text-start'}
                          onClick={() => {
                              props.setIsFromSettings(true)
                              props.setReminderRepeat(t('daily'))
                              props.setShowRepeat(false)

                          }}>
                        <p
                            className={'text-start mb-0 small'}> {t('daily')}</p></Link>

                </Col>

            </Row>
            <Row className={'align-items-center mx-0  mb-3'}>

                <Col md={12} className={'px-1 '}>
                    <Link className={'btn btn-secondary w-100 text-black border-groove text-start'}
                          onClick={() => {
                              props.setIsFromSettings(true)
                              props.setReminderRepeat(t('once'))
                              props.setShowRepeat(false)
                          }}>
                        <p
                            className={'text-start mb-0 small'}> {t('once')}</p>
                    </Link>
                </Col>

            </Row>
            <Row className={'align-items-center mx-0  mb-3'}>

                <Col md={12} className={'px-1'}>
                    <Link className={'btn btn-secondary w-100 text-black border-groove text-start'}
                          onClick={() => {
                              props.setFromReminder(true)
                              props.navigateToComponent('time')
                              props.setReminderRepeat(t('timer'))
                              props.setShowRepeat(false)
                          }}>
                        <p
                            className={'text-start mb-0 small'}> {t('timer')}</p>
                    </Link>
                </Col>

            </Row>

        </Col>
    )
}

export default ShowReminderSchedule